<template>
  <div v-if="department" class="mt-26">
    <v-row class="background-color-white position-fixed z-index-2">
      <!-- comp -->
      <v-col class="d-flex primary--text pb-1">
        <div class="align-center d-flex pl-3">
          <Icon
            :name="department.src"
            :color="$vuetify.theme.themes.light.primary"
            :title="department.name"
            class="mr-1"
          ></Icon>
          <h3 class="font-weight-semibold text-no-wrap">
            {{ department.name }}
          </h3>
        </div>
      </v-col>
      <!-- comp -->
      <NavigationSwiper :fixed="true" :menuItems="subDepartments" />
    </v-row>
    <v-row
      v-for="category in department.sub_categories"
      :id="slug(category.category_name.replace(/^\d/, 'abc$&'))"
      :key="category.category_name"
      class="background-color-white mb-3"
      no-gutters
    >
      <!-- comp -->
      <v-col cols="9" class="d-flex primary--text py-2 text-truncate">
        <div class="pl-4">
          <h4 class="font-weight-medium text-no-wrap">
            {{ category.category_name }}
          </h4>
        </div>
      </v-col>
      <v-col cols="3" class="d-flex justify-center">
        <router-link
          class="align-center d-flex font-size-sm"
          :to="{
            name: 'category',
            params: { categoryId: category.category_id },
          }"
        >
          View All
          <v-icon color="primary">mdi-chevron-right</v-icon>
        </router-link>
      </v-col>
      <!-- comp -->
      <v-col cols="12">
        <v-sheet :max-width="fixedRowWidth">
          <swiper :options="{ slidesPerView: 2.25 }">
            <swiper-slide
              class="d-flex justify-center"
              v-for="product in category.products"
              :key="product.upc"
            >
              <Product :product="product" :size="'xs'" />
            </swiper-slide>
          </swiper>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { slug } from "github-slugger";
import Product from "@/components/Product/index.vue";
import Icon from "@/components/UI/Icon.vue";
import NavigationSwiper from "@/components/Navigation/Xs/Swiper.vue";

const offset = { scroll: 480, click: 300 };

export default {
  name: "XsDepartment",
  components: { Icon, NavigationSwiper, Product },
  computed: {
    fixedRowWidth() {
      return this.innerWidth;
    },
    subDepartments() {
      return this.department.sub_categories.reduce((acc, i) => {
        acc[i.category_name] = acc[i.category_name] || [];
        acc[i.category_name].push(i);
        return acc;
      }, {});
    },
  },
  created() {
    window.addEventListener("resize", this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      offset: offset.scroll,
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.setInnerWidth);
  },
  methods: {
    // formatToFileName,
    offsetAtHeader() {
      this.offset = offset.click;
    },
    onItemChanged(event, currentItem) {
      this.swiper.slideTo(currentItem.id, false, false);
      this.offset = offset.scroll;
    },
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    },
    slug,
  },
  props: { department: Object },
};
</script>
<style scoped>
.mt-26 {
  margin-top: 72px;
}

.active-side-nav {
  background-color: var(--v-primary-base) !important;
  color: var(--color-white) !important;
}

.position-fixed {
  position: fixed;
  top: 197px;
  left: 0;
  /*top: 185px;*/
}

.z-index-2 {
  z-index: 2;
}
</style>
